import { DeviceType } from 'core/constants';
import { ModelBase } from 'store/model-base';
import { ProductDetails } from './product-details';

export class LineBySessionId extends ModelBase {
    public static storeName: string = 'lineBySessionId';

    public lineId: string;
    public category: string;
    public mdn: string;
    public imei: string;
    public transferPairedLines: boolean;
    public nickName: string;
    public status: string;
    public productDetails: ProductDetails;
    public devicePaymentPlan: LineTransferDevicePaymentPlan;
    public insurancePlan: LineTransferInsurancePlan;
    public cancelReason: string;
    
    public hasProtectionPlan: boolean;
    public isPhone: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.hasProtectionPlan = Boolean(data.insurancePlan);
        data.isPhone = data.category === DeviceType.PHONE;

        return super.create<T>(data);
    }
}

